import { useFeatureFlags } from '@brightdrop/feature-flags-client';

/**
 * LaunchDarkly flag key for the AI Sidekick M1 rollout.
 *
 * This flag is independent of the existing Sidekick UI and transport
 * gates so M1 capabilities can be released separately.
 */
export const AI_SIDEKICK_M1_FLAG = 'SDPCDXP-1986-AI-SIDEKICK-FE-M1';

/**
 * Resolves whether AI Sidekick M1 capabilities are enabled for the
 * current LaunchDarkly context.
 *
 * Only the boolean literal `true` enables M1. Missing or non-boolean
 * values fail closed.
 *
 * @returns Whether AI Sidekick M1 capabilities are enabled.
 */
export function useIsSidekickM1Enabled(): boolean {
  const { getFlag } = useFeatureFlags();
  return getFlag(AI_SIDEKICK_M1_FLAG) === true;
}
